import { Graph, Pipeline } from '../store/data/types';
import { IEdge, INode } from 'react-digraph';

const setNodes = (pipeline: Pipeline, nodes: INode[]): Pipeline => {
  return {
    ...pipeline,
    graph: {
      ...pipeline.graph,
      nodes,
    },
  };
};

const setEdges = (pipeline: Pipeline, edges: IEdge[]): Pipeline => {
  return {
    ...pipeline,
    graph: {
      ...pipeline.graph,
      edges,
    },
  };
};

const setGraph = (pipeline: Pipeline, graph: Graph): Pipeline => {
  return {
    ...pipeline,
    graph,
  };
};

const PipelineReducer = {
  setNodes,
  setEdges,
  setGraph,
};

export default PipelineReducer;
